import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "@env/environment";
import {ActivatedRouteSnapshot, Resolve, Router} from "@angular/router";
import {Observable} from "rxjs";
import {catchError} from "rxjs/operators";

@Injectable()
export class OptionsService implements Resolve<any> {
  public Options: any = {};

  constructor(private _http: HttpClient, private router: Router) {
  }

  public loadOptions(): Observable<any> {
    return this._http.get(environment.elasticReader.host + environment.elasticReader.options, {headers:environment.elasticReader.headers}).pipe(
               catchError(
                 error => {
                   this.router.navigate(["/404"], {queryParams:{error:JSON.stringify(error)}});
                   return [];
                 }
               ));
  }

  public loadStreets(street: string) {
    let queryBody = {
      "size":0,
      "_source":[
        "primary_address.street_name"
      ],
      "sort":[
        {
          "primary_address.street_name":{
            "order":"asc"
          }
        }
      ],
      "query":{
        "query_string":{
          "default_field":"primary_address.street_name",
          "query":street.toUpperCase() + "*"
        }
      },
      "aggs":{
        "streets":{
          "terms":{
            "field":"primary_address.street_name",
            "size":10
          }
        }
      }
    };
    return this._http.post(environment.elasticReader.host + environment.elasticReader.lookup, queryBody).pipe(catchError(
      error => {
        this.router.navigate(["/404"], {queryParams:{error:JSON.stringify(error)}});
        return [];
      }
    ));
  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.loadOptions();

  }
}
